import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetCustomerSources Input Action
 */
export class GetCustomerSourcesInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `customerSources`;
    public getCacheObjectType = () => 'customerSources';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetCustomerSourcesData {
    key: string;
    value: string;
    CustomerSourceReferralCode?: string;
    ExtensionProperties: any[];
}

export interface ICustomerSources {
    CustomerSourceCode: string;
    CustomerSourceDescription: string;
    CustomerSourceReferralCode: string;
    ExtensionProperties: any[];
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCustomerSourcesInput();
};

async function action(_: GetCustomerSourcesInput, ctx: Msdyn365.IActionContext): Promise<IGetCustomerSourcesData[]> {
    let sourceList: ICustomerSources[] = [];

    try {
        const res = await Msdyn365.sendRequest(
            `${ctx.requestContext.apiSettings.baseUrl}Commerce/TecGetAllCustomerSources(languageId='${ctx.requestContext.locale}')`,
            'get',
            {},
            { headers: { OUN: ctx.requestContext.apiSettings.oun } }
        );
        sourceList = (res?.data as any).value ?? [];
    } catch (ex) {
        console.log('Error fetching customer sources, using mock data', ex);
    }

    // Map to IGetCustomerSourcesData[]
    const customerSources: IGetCustomerSourcesData[] = sourceList.map((val: ICustomerSources) => ({
        key: val.CustomerSourceCode,
        value: val.CustomerSourceDescription,
        CustomerSourceReferralCode: val.CustomerSourceReferralCode,
        ExtensionProperties: val.ExtensionProperties ?? []
    }));

    return customerSources;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCustomerSourcesData[]>>action,
    id: 'GetCustomerSources',
    input: createInput
});
